import styled from 'styled-components'

import { baseFont } from '~/shared/styles/font'

export const P = styled.p`
  ${baseFont}
  font-size: ${(props) =>
    // @ts-expect-error TS(2339) FIXME: Property 'size' does not exist on type 'ThemedStyl... Remove this comment to see the full error message
    props.size}px;
  font-weight: ${(props) =>
    // @ts-expect-error TS(2339) FIXME: Property 'weight' does not exist on type 'ThemedSt... Remove this comment to see the full error message
    props.weight};
  line-height: ${(props) =>
    // @ts-expect-error TS(2339) FIXME: Property 'size' does not exist on type 'ThemedStyl... Remove this comment to see the full error message
    props.size + 6}px;
  color: ${(props) => props.color};
  user-select: none;
`
